import { EntryRenderer } from "./EntryRenderer";
import { PageModel } from "../../types/PageModel";
import { readFragment } from "gql.tada";
import { useTheme } from "../../hooks/useTheme";
import { useLayoutEffect, useMemo } from "react";
import { ThemeFragment } from "../../queries/fragments/ThemeFragment";
import { isValidTheme } from "../../types/ThemeModel";
import { defaultTheme } from "../../utils/ThemeContext";
import { PageContext } from "../../utils/PageContext";
import { MetadataHelmet } from "./MetadataHelmet";
import { useScrollResetOnMount } from "../../hooks/useScrollResetOnMount";

export const Page = ({ page }: { page: PageModel }) => {
  useScrollResetOnMount();

  const { setTheme } = useTheme();
  const theme = useMemo(
    () => readFragment(ThemeFragment, page.page.theme) ?? defaultTheme,
    [page.page.theme]
  );

  useLayoutEffect(() => {
    if (!isValidTheme(theme)) {
      console.warn(`Palette combination invalid: `, theme);
      return;
    }

    setTheme(theme);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [theme]);

  return (
    <PageContext.Provider value={page}>
      <MetadataHelmet page={page.page} />
      {page.hero && <EntryRenderer pageBlockInstance={page.hero} />}
      {page.blocks.map(
        (block, index) =>
          !!block && <EntryRenderer key={index} pageBlockInstance={block} />
      )}
    </PageContext.Provider>
  );
};
